<template>
  <div class="wrapper">
    <!-- <div class="search-wrapper">
      <img class="search-btn" src="/static/img/search.png" alt>
      <input class="search-input" type="text" placeholder="关键字搜索">
    </div> -->
     <search></search>
    <div class="slide-wrapper">
      <ul>
        <li
          class="first-title"
          :class="{'first-title-active':item.newsFlag ==$route.query.newsFlag}"
          v-for="(item,index) in slideList"
          :key="index"
          @click="toPage({name:'NewsList',query:{newsFlag:item.newsFlag}})"
        >
          <span class="circle"></span>
          {{item.title}}
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  /* width: 310px;
  margin-right: 30px; */
}
.search-wrapper {
  width: 100%;
  height: 40px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
.slide-wrapper {
  width: 100%;
  background: #e6ecf2;
  border-radius: 10px;
  padding: 20px 0;
  box-sizing: border-box;
}
.first-title {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #cdd7e2;
  color: #1e4cb0;
  font-size: 18px;
  padding-left: 40px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  background: #F7F7F7;
}
.first-title .circle {
  position: absolute;
  top: 50%;
  left: 16px;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  background: #fff;
  border: 3px solid #1e4cb0;
  border-radius: 50%;
  box-sizing: border-box;
}
.first-title-active .circle {
  background: #1e4cb0;
  border: 3px solid #ffffff;
}
.first-title-active::after{
  position: absolute;
  content: ">";
  top: 0;
  right: 10px;
}
.first-title-active {
  background: url(/static/img/common-nav.png) no-repeat center center;
  background-size: 100% 60px;
  color: #fff;
}
</style>

<script>
import search from "@/components/views/common/search.vue";
export default {
  props: ["slideList"],
  data() {
    return{}
  },
  methods: {
    toPage(url) {
      this.$router.push(url);
    }
  },
      components: {
    search
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/News/slide.vue